export default "__VITE_ASSET__BZTT8X5w__"